import { render, staticRenderFns } from "./PromoPlanCard.vue?vue&type=template&id=0ae4be87&scoped=true&"
import script from "./PromoPlanCard.vue?vue&type=script&lang=js&"
export * from "./PromoPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae4be87",
  null
  
)

export default component.exports